"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformToCoreAddress = exports.transformToAVSAddress = void 0;
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var transformToAVSAddress = exports.transformToAVSAddress = function transformToAVSAddress(source) {
  return {
    streetAddressLine: (0, _prop["default"])('line1')(source),
    streetAddressLine2: (0, _prop["default"])('line2')(source),
    cityOrLocality: (0, _prop["default"])('city')(source),
    administrativeAreaAbbreviation: (0, _prop["default"])('stateProvince')(source),
    zipOrPostalCode: (0, _prop["default"])('postalCode')(source),
    countryIso3166Code: (0, _prop["default"])('country')(source)
  };
};
var transformToCoreAddress = exports.transformToCoreAddress = function transformToCoreAddress(source) {
  return {
    line1: (0, _prop["default"])('streetAddressLine')(source),
    line2: (0, _prop["default"])('streetAddressLine2')(source),
    city: (0, _prop["default"])('cityOrLocality')(source),
    stateProvince: (0, _prop["default"])('administrativeAreaAbbreviation')(source),
    postalCode: (0, _prop["default"])('zipOrPostalCode')(source),
    country: (0, _prop["default"])('countryIso3166Code')(source)
  };
};